// config.ts
import { Config } from "@adornis/config/config.js";
var importExportConfig = new Config("import-export", {
  cache: {
    env: true,
    name: "IMPORT_EXPORT_CACHE",
    required: false,
    client: false,
    defaultVal: "/tmp/import-export"
  }
});
export {
  importExportConfig
};
